import type { ImeiHubServiceId } from '@redevicer/shared'

const HERO_BY_SERVICE: Record<ImeiHubServiceId, string> = {
  verify: '/images/imei-hub/imei-hub-hero-verify.jpg',
  passport: '/images/imei-hub/imei-hub-hero-passport.jpg',
  lock: '/images/imei-hub/imei-hub-hero-lock.jpg',
  carrier: '/images/imei-hub/imei-hub-hero-carrier.jpg',
  safecheck: '/images/imei-hub/imei-hub-hero-safecheck.jpg',
  business: '/images/imei-hub/imei-hub-hero-business.jpg',
  android: '/images/imei-hub/imei-hub-hero-android.jpg',
  gsx: '/images/imei-hub/imei-hub-hero-gsx.jpg',
  tmobile: '/images/imei-hub/imei-hub-hero-tmobile.jpg',
}

/** Service-specific hero illustration for verify reports and hub previews. */
export function imeiHubHeroImage(service: ImeiHubServiceId): string {
  return HERO_BY_SERVICE[service] ?? HERO_BY_SERVICE.verify
}
